import {
    MapPin,
    Phone,
    Mail,
    Instagram,
    Youtube,
    Linkedin,
    Facebook,
    X,
    Twitter,
} from "lucide-react";
import { BsWhatsapp } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

function Footer() {
    const navigate = useNavigate();

    return (
        <div>
            <footer className="bg-dark text-white">
                <div className="container mx-auto px-6 py-12">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                        {/* ===== Address & Contact ===== */}
                        <div className="space-y-4">
                            {/* <div className="flex items-start space-x-3">
                                <MapPin className="w-5 h-5 mt-1 flex-shrink-0" />
                                <div>
                                    <p className="text-purple-100">
                                        Near Pro4 Socio, Spice Garden Layout,
                                        Marathahalli, Bangalore, Karnataka,
                                        560037
                                    </p>
                                    <a
                                        href="https://maps.google.com"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-sm text-purple-200 hover:text-white underline mt-2 inline-block"
                                    >
                                        Click to open in Google Maps
                                    </a>
                                </div>
                            </div> */}

                            <div className="flex items-start space-x-3">
                                <MapPin className="w-5 h-5 mt-1 flex-shrink-0" />
                                <div>
                                    <p className="text-purple-100">
                                        Near Pro4 Socio, Spice Garden Layout,
                                        Marathahalli, Bangalore, Karnataka,
                                        560037
                                    </p>
                                    <a
                                        href="https://www.google.com/maps?q=12.959083,77.709778"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-sm text-purple-200 hover:text-white underline mt-2 inline-block"
                                    >
                                        Click to open in Google Maps
                                    </a>
                                </div>
                            </div>

                            <div className="flex items-center space-x-3">
                                <Phone className="w-5 h-5" />
                                <a
                                    href="tel:+917398747222"
                                    className="hover:text-purple-200 transition"
                                >
                                    +91-7398747222
                                </a>
                            </div>

                            <div className="flex items-center space-x-3">
                                <Mail className="w-5 h-5" />
                                <a
                                    href="mailto:info@boomontrip.com"
                                    className="hover:text-purple-200 transition"
                                >
                                    info@boomontrip.com
                                </a>
                            </div>

                            {/* ===== Social Media Links (ADDED) ===== */}
                            <div>
                                <p className="font-semibold mt-4 mb-2">
                                    Follow Us
                                </p>
                                <div className="flex items-center space-x-4">
                                    <a
                                        href="https://www.instagram.com/boomontrip/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="hover:text-pink-400 transition"
                                    >
                                        <Instagram />
                                    </a>

                                    <a
                                        href="https://www.youtube.com/@BoomOnTrip"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="hover:text-red-500 transition"
                                    >
                                        <Youtube />
                                    </a>

                                    <a
                                        href="https://www.linkedin.com/company/boomontrip"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="hover:text-blue-400 transition"
                                    >
                                        <Linkedin />
                                    </a>

                                    <a
                                        href="https://x.com/booomontrip/company/boomontrip"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="hover:text-blue-400 transition"
                                    >
                                        <Twitter />
                                    </a>

                                    <a
                                        href="https://www.facebook.com/booomontrip/company/boomontrip"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="hover:text-blue-400 transition"
                                    >
                                        <Facebook />
                                    </a>
                                </div>
                            </div>
                        </div>

                        {/* ===== Company ===== */}
                        <div>
                            <h3 className="text-xl font-bold mb-4">Company</h3>
                            <ul className="space-y-2">
                                <li
                                    className="text-purple-100 cursor-pointer hover:text-white transition"
                                    onClick={() => navigate("/about")}
                                >
                                    About Us
                                </li>
                                <li
                                    className="text-purple-100 cursor-pointer hover:text-white transition"
                                    onClick={() => navigate("/refund-policy")}
                                >
                                    Refund Policy
                                </li>

                                <li
                                    className="text-purple-100 cursor-pointer hover:text-white transition"
                                    onClick={() => navigate("/contact")}
                                >
                                    Contact Us
                                </li>
                            </ul>
                        </div>

                        {/* ===== Support ===== */}
                        <div>
                            <h3 className="text-xl font-bold mb-4">Support</h3>
                            <ul className="space-y-2">
                                <li>
                                    <a
                                        href="/help"
                                        className="text-purple-100 hover:text-white transition"
                                    >
                                        Help Center
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="/terms"
                                        className="text-purple-100 hover:text-white transition"
                                    >
                                        Terms of Service
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="/privacy"
                                        className="text-purple-100 hover:text-white transition"
                                    >
                                        Privacy Policy
                                    </a>
                                </li>

                            </ul>
                        </div>

                        {/* ===== Trip Types ===== */}
                        <div>
                            <h3 className="text-xl font-bold mb-4">
                                Trip Types
                            </h3>
                            <ul className="space-y-2">
                                <li>
                                    <a
                                        href="/trips/all"
                                        className="text-purple-100 hover:text-white transition"
                                    >
                                        All Trips
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="/trips/2-days"
                                        className="text-purple-100 hover:text-white transition"
                                    >
                                        2 Days
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="/trips/1-day"
                                        className="text-purple-100 hover:text-white transition"
                                    >
                                        1 Day
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                {/* ===== Bottom Bar ===== */}
                <div className="border-t border-purple-400/30 py-4">
                    <div className="container mx-auto px-6 text-center">
                        <p className="text-purple-100">
                            © 2026 BoomOnTrip. All rights reserved.
                        </p>
                    </div>
                </div>

                {/* ===== Floating Buttons ===== */}
                <div style={{ zIndex: '99' }} className="fixed bottom-6 right-6 flex flex-col space-y-3">
                    <a
                        href="https://wa.me/7398747222"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-lg transition transform hover:scale-110"
                        aria-label="Contact on WhatsApp"
                    >
                        <BsWhatsapp size={24} />
                    </a>

                    <a
                        href="tel:+917398747222"
                        className="bg-blue-500 hover:bg-blue-600 text-white rounded-full p-4 shadow-lg transition transform hover:scale-110"
                        aria-label="Call us"
                    >
                        <Phone className="w-6 h-6" />
                    </a>
                </div>
            </footer >
        </div >
    );
}

export default Footer;
